import { NextSeo } from "next-seo"
import { useRouter } from "next/router"

import image, { CATEGORY_TREASURE } from "lacinetek-common/src/images"

import { useTranslation } from "lib/i18n/translation"
import { useCountry } from "lib/country"
import { FETCH_TREASURE } from "lib/graphql/queries"
import Gtm from "lib/gtm"

import { Query } from "components/common"
import { Nav, Films } from "components/treasure"
import Products from "components/common/products"
import {
	baseProduct,
	baseTreasure
} from "components/common/skeleton"
import Image from "components/common/image"

const Collection = ({ slug }) => {
	const { c } = useTranslation("common")
	const router = useRouter()
	const url = router ? router.asPath : null

	return (
		<>
			<Gtm
				pageType="Trésor caché - collection"
				pagePath={url}
				pageTitle={c("collection")}
			/>
			<Query
				query={FETCH_TREASURE}
				options={{ variables: { query: `linkRewrite.value:"${slug}"` } }}
				renderLoading={() => (
					<>
						<Nav />
						<Header collection={baseTreasure} loading={true} />
						<Films
							products={[...Array(10)].map((i, index) => baseProduct)}
							loading={true} />
					</>
				)}
			>
				{({ cms: { categories: { items: [collection] } } }) => (
					<Products products={collection.products.items}>
						{products => (
							<>
								<Nav />
								<Header collection={collection} />
								<Films products={products} />
							</>
						)}
					</Products>
				)}
			</Query>
		</>
	)
}

export const getInitialProps = async (ctx) => {
	return {
		slug: ctx.query.collection,
		treasureSlug: ctx.query.id
	}
}

Collection.getInitialProps = getInitialProps

const Header = ({ collection, loading }) => {
	const { c } = useTranslation("common")
	const { asPath } = useCountry()

	return (
		<>
			<NextSeo
				title={collection.metaTitle || collection.name}
				description={collection.metaDescription || collection.descriptionShort}
				keywords={collection.metaKeywords}
				canonical={asPath}
				openGraph={{
					type: "article",
					title: collection.metaTitle !== ""
						? collection.metaTitle
						: collection.name,
					description: collection.metaDescription !== ""
						? collection.metaDescription
						: `${c("collection-of")} ${collection.name}`,
					url: asPath,
					images: [{ url: image(collection, CATEGORY_TREASURE) }],
					image: { url: image(collection, CATEGORY_TREASURE) }
				}}
			/>
			<section className={`focus black has-splitted ${loading ? "skel-loading" : ""}`}>
				<div className="splitted invert">
					<figure className="skel">
						<picture>
							<Image
								src={loading ? "/static/images/default_corpus.jpg" : image(collection, CATEGORY_TREASURE)}
								className="cover"
								alt={collection.name}
							/>
						</picture>
					</figure>
					<div className="content">
						<h1 className="title-alt skel">{c("collection")}<br /><strong>{collection.name}</strong></h1>
						<div className="description skel" dangerouslySetInnerHTML={{ __html: collection.description }} />
					</div>
				</div>
			</section>
		</>
	)
}

export default Collection
